/**
 * @returns {Function} Формирование времени hh:mm:ss из timestamp
 *
 * @param {Number} timestamp Время в секундах
 * @param isDateObject
 */
export default (timestamp, isDateObject = false) => {
    let date;
    if (isDateObject) {
        date = timestamp;
    } else {
        date = new Date();
        date.setTime(parseInt(timestamp) * 1000);
    }
    const hours = date.getHours().toString().length < 2 ?
        '0' + date.getHours().toString() : date.getHours().toString();
    const minutes = date.getMinutes().toString().length < 2 ?
        '0' + date.getMinutes().toString() : date.getMinutes().toString();
    // const seconds = date.getSeconds();

    return `${hours}:${minutes}`;
};
